import type Module from 'mini-common-schema/lib/schema/Module';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { closeNPSFormAction } from 'mini-nps/lib/actions/closeNPSFormAction';

export function npsModuleRouterHandler() {
    switchModule(9);
}

export function npsModuleCleanupRouterHandler(): boolean {
    closeNPSFormAction();
    return false;
}
